// store.js
import { reactive } from 'vue';

const HISTORY_STORAGE_KEY = 'shipin_watch_history';
const MAX_HISTORY_ITEMS = 50;

const isBrowser = () => typeof window !== 'undefined';

const readHistoryFromStorage = () => {
	if (!isBrowser()) return [];
	try {
		const raw = localStorage.getItem(HISTORY_STORAGE_KEY);
		if (!raw) return [];
		const parsed = JSON.parse(raw);
		return Array.isArray(parsed) ? parsed : [];
	} catch (error) {
		console.warn('Failed to read watch history from storage:', error);
		return [];
	}
};

const writeHistoryToStorage = (list) => {
	if (!isBrowser()) return;
	try {
		localStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(list));
	} catch (error) {
		console.warn('Failed to persist watch history:', error);
	}
};

export const store = reactive({

	/* 过滤的渠道号。如果是以下这些渠道号，就不显示
	1.顶部的域名广告通知，
	2.顶部的保存网址
	3.底部的广告 Footer
	*/
	filterQudaolist: [
		'haijiao-xpj', 
		'haijiao-pg',
		'haijiao-yinhe',
		'haijiao51zhibo',
		'haijiao-xiangfei',
		'haijiao-xingba',
		'haijiao-kaiyuan',
		'haijiao77',
		'haijiao-xpj01',
		'haijiao-aizhibo'
	],
	config: {},
	// track config fetch stages
	configLoaded: false,
	configLoadedWithChannel: false,
	adsList: [],

	// Cached datasets to avoid duplicate requests
	categoryList: [],
	categoryLoading: false,
	noticeList: [],
	noticeLoading: false,
	cateList: [],
	cateLoading: false,
	adsIdConfig: {
		'/home': '1,5,6,11,12',
		'/details': '1,3,4,6,9,11,13',
		'/more': '1,6,11',
		'/search': '6,11'
	},

	// Global download bar state
	downloadBarVisible: false,
	downloadBarHeight: 0,
	setDownloadBarVisible: (value) => {
		store.downloadBarVisible = !!value;
		if (!value) store.downloadBarHeight = 0;
	},
	setDownloadBarHeight: (value) => {
		store.downloadBarHeight = Number(value) || 0;
	},
	setConfig: (config) => {
		store.config = config;
	},
	markConfigInitial: () => {
		store.configLoaded = true;
		store.configLoadedWithChannel = false;
	},
	markConfigWithChannel: () => {
		store.configLoaded = true;
		store.configLoadedWithChannel = true;
	},
	setAdsList: (value) => {
		value.forEach((v) => {
			if (store.isDev()) {
				// v.icon = require('@/assets/logo.png')
				v.name = 'name';
			}
		});
		store.adsList = value;
	},
	setCategoryList: (list) => {
		store.categoryList = Array.isArray(list) ? list : [];
	},
	setNoticeList: (list) => {
		store.noticeList = Array.isArray(list) ? list : [];
	},
	setCateList: (list) => {
		store.cateList = Array.isArray(list) ? list : [];
	},
	isDev: () => {
		// return process.env.NODE_ENV === "development"
		return false;
	},
	homeIndexCurrent: 1,
	setHomeIndexCurrent: (value) => {
		store.homeIndexCurrent = value;
	},
	homeScrollTop: 0,
	setHomeScrollTop: (value) => {
		const next = Number(value);
		store.homeScrollTop = Number.isFinite(next) ? next : 0;
	},
	homeVideoList: [],
	homeDataLoaded: false,
	setHomeVideoList: (list) => {
		store.homeVideoList = Array.isArray(list) ? [...list] : [];
		store.homeDataLoaded = store.homeVideoList.length > 0;
	},
	clearHomeVideoList: () => {
		store.homeVideoList = [];
		store.homeDataLoaded = false;
	},

	watchHistory: [],
	watchHistoryLoaded: false,
	loadWatchHistory: () => {
		const list = readHistoryFromStorage();
		store.watchHistory = Array.isArray(list) ? [...list] : [];
		store.watchHistoryLoaded = true;
		return store.watchHistory;
	},
	addWatchHistory: (video) => {
		if (!store.watchHistoryLoaded) {
			store.loadWatchHistory();
		}
		if (!video || (!video.id && !video.aid)) return;
		const id = video.id ?? video.aid;
		const payload = {
			id,
			title: video.title ?? '',
			upload_thumb: video.upload_thumb ?? '',
			href: video.href ?? '',
			create_date: video.create_date ?? '',
			watchtimes: video.watchtimes ?? 0,
			duration: video.duration ?? '',
			playedAt: Date.now()
		};
		const next = [
			payload,
			...store.watchHistory.filter(item => item.id !== id)
		].slice(0, MAX_HISTORY_ITEMS);
		store.watchHistory = next;
		writeHistoryToStorage(next);
	},
	clearWatchHistory: () => {
		store.watchHistoryLoaded = true;
		store.watchHistory = [];
		writeHistoryToStorage([]);
	},
	removeWatchHistoryItem: (id) => {
		if (!store.watchHistoryLoaded) {
			store.loadWatchHistory();
		}
		if (id === undefined || id === null) return;
		const next = store.watchHistory.filter(item => item.id !== id);
		store.watchHistory = next;
		writeHistoryToStorage(next);
	}
});
